
import {createContext, useState} from 'react'

const Context = createContext()

export const EmailContextProvider = ({children}) => {
 const [allEmails, setAllEmails] = useState([]);
 const [emails, setEmails] = useState([]);
 const [email, setEmail] = useState({});
 const [vinculedEmails, setVinculedEmails] = useState([]);
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })
 return <Context.Provider value={{allEmails, setAllEmails, emails, vinculedEmails, setVinculedEmails, setEmail, setEmails, email, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context